import { Currency } from "../constants/general-basic-data";

export class Country {
    id: number = 0;
    code = '';
    name = '';
    phoneCode: number = 0;
    currency: Currency;
    otherCurrencies: Currency[] = [];

    created = '';
    lastUpdated = '';
    lastUpdatedBy = '';
  
    constructor (code: string, name: string, phoneCode: number, currency: Currency)  {
      this.code = code!;
      this.name = name!;
      this.phoneCode = phoneCode!;
      this.currency = currency!;

    }
  }
  